import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";
import {ErrorService} from "../../service/error.service";

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) private snackbar, private errorService: ErrorService,  private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.init();
  }

  init() {

    this.errorService.getSpinnerObserver().subscribe(() => {
      this.snackbar.openSnackBar();
      this.cdRef.detectChanges();
    });
  }
  closeSnackBar(){
    this.snackbar.preClose();
  }

  reload(){
    this.closeSnackBar();
    window.location.reload();
  }



}
